import { render, staticRenderFns } from "./answerSheet.vue?vue&type=template&id=14b1c01c&scoped=true"
import script from "./answerSheet.vue?vue&type=script&lang=js"
export * from "./answerSheet.vue?vue&type=script&lang=js"
import style0 from "./answerSheet.vue?vue&type=style&index=0&id=14b1c01c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b1c01c",
  null
  
)

export default component.exports